<template>
  <div>
    <work-place-add-new
      :is-add-new-work-place-sidebar-active.sync="isAddNewWorkPlaceSidebarActive"
      @refresh-data="() => { refWorkPlaceList.refreshData() }"
    />
    <list
      ref="refWorkPlaceList"
      sort-by="sucursalId"
      :refetch-records="fetchWorkPlaces"
      refetch-records-name="lugaresTrabajo"
      :actions="actions"
      key-field="sucursalId"
      :table-columns="tableColumns"
      :table-actions="tableActions"
      :delete-method="deleteWorkPlace"
      :filters.sync="filters"
    />
  </div>
</template>
<script>
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import List from '@/components/List.vue'
import humanResources from '@/services/humanresources.service'
import WorkPlaceAddNew from './WorkPlaceAddNew.vue'

export default {
  components: {
    WorkPlaceAddNew,
    List,

  },
  setup() {
    /* Refs */
    const refWorkPlaceList = ref(null)
    const isAddNewWorkPlaceSidebarActive = ref(false)
    /* Services */
    const { fetchWorkPlaces, fetchWorkPlace, deleteWorkPlace } = humanResources()
    /* Data */
    const tableColumns = [
      {
        label: i18n.t('humanResources.workPlace.columns.workPlace'),
        key: 'nombre',
      },
      {
        label: i18n.t('humanResources.workPlace.columns.description'),
        key: 'descripcion',
      },
      {
        label: i18n.t('Lists.Actions'),
        key: 'actions',
      },
    ]
    const tableActions = ref([
      {
        name: 'edit',
        label: i18n.t('Lists.Edit'),
        aclAction: 'create',
        aclResource: 'lugarTrabajo',
        routeName: 'apps-human-resources-work-place-edit',
        params: ['sucursalId'],
        icon: 'CodepenIcon',
      },
      {
        name: 'delete',
        label: i18n.t('Lists.Delete'),
        aclAction: 'delete',
        aclResource: 'lugarTrabajo',
        params: ['sucursalId'],
        icon: 'TrashIcon',
      },
    ])
    const actions = ref([
      {
        label: i18n.t('humanResources.workPlace.list.newWorkPlaceAction'),
        aclAction: 'create',
        click: () => { isAddNewWorkPlaceSidebarActive.value = true },
        icon: 'PlusCircleIcon',
      },
    ])
    const filters = ref([])
    return {
      // Refs
      refWorkPlaceList,
      tableColumns,
      isAddNewWorkPlaceSidebarActive,
      tableActions,
      actions,
      filters,
      // API calls
      fetchWorkPlaces,
      fetchWorkPlace,
      deleteWorkPlace,
    }
  },
}
</script>
<style lang="scss" scoped>

</style>
